import { Component, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { Router } from '@angular/router';
import { PermissionService } from 'src/app/services/permission.service';
import Tooltip from 'bootstrap/js/dist/tooltip';

@Component({
  selector: 'app-carta-porte-actions',
  templateUrl: './carta-porte-actions.component.html',
  styleUrls: ['./carta-porte-actions.component.css']
})
export class CartaPorteActionsComponent implements AfterViewInit, OnDestroy {
  private tooltips: any[] = [];

  constructor(
    private permissionService: PermissionService,
    private el: ElementRef<HTMLElement>,
    private router: Router
  ) { }

  public cellValue!: any;

  agInit(params: ICellRendererParams): void {
    this.cellValue = params;
  }

  refresh(params: ICellRendererParams) {
    this.cellValue = params;
    return true;
  }

  ngAfterViewInit(): void {
    const tooltipTriggerList = Array.from(
      this.el.nativeElement.querySelectorAll('[data-bs-toggle="tooltip"]')
    ) as HTMLElement[];
    this.tooltips = tooltipTriggerList.map(el => new Tooltip(el));
  }

  ngOnDestroy(): void {
    this.tooltips.forEach(t => t.dispose());
    this.tooltips = [];
  }

  canDo(action: string) {
    const module = this.cellValue?.module || 'Carta Porte';
    return this.permissionService.canDo(module, action);
  }

  get isDraft(): boolean {
    return this.cellValue?.data?.cfdi_status === 'draft';
  }

  deleteEvent() {
    this.cellValue.parent.actionDelete(this.cellValue.data.id);
  }

  stampEvent() {
    const serviceId = Number(this.cellValue?.data?.service_id);
    if (serviceId) {
      this.cellValue.parent.actionStamp(serviceId);
    }
  }

  downloadEvent() {
    const cartaPorteId = Number(this.cellValue?.data?.id);
    if (cartaPorteId) {
      this.cellValue.parent.actionDownload(cartaPorteId);
    }
  }

  downloadPdfEvent() {
    const cartaPorteId = Number(this.cellValue?.data?.id);
    if (cartaPorteId) {
      this.cellValue.parent.actionDownloadPdf(cartaPorteId);
    }
  }

  viewEvent() {
    const cartaPorteId = Number(this.cellValue?.data?.id);
    if (!cartaPorteId) {
      return;
    }

    this.router.navigate(
      ['/carta-porte/view', cartaPorteId],
      { queryParams: { folio: this.cellValue?.data?.service_folio || this.cellValue?.data?.service?.folio } }
    );
  }
}
